class MenuDesktop extends Menu {
  constructor(element, options = {}) {
    const settings = {
      menuClassName: 'menu-desktop',
      ...options
    }
    super(element, settings);
  }

  addEventListeners() {
    super.addEventListeners();

    this.$items.forEach(item => {
      const itemAlias = item.dataset.alias;
      const withChildren = item.classList.contains(`${Menu.MENU_ITEM_CLASS}--with-children`);
      const parentSubmenu = item.closest('.menu-desktop__level');
      const parentLevel = parentSubmenu.dataset.level === undefined ? -1 : Number(parentSubmenu.dataset.level);

      if (withChildren) {
        item.addEventListener('mouseenter', () => {
          this.showSubmenu();
          this.setActiveAlias(parentLevel + 1, itemAlias);
        });

        item.addEventListener('mouseleave', () => {
          this.hideSubmenu(parentLevel + 1);
        });
      }
    });

    this.$submenus.forEach(submenu => {
      submenu.addEventListener('mouseenter', () => {
        this.showSubmenu(Number(submenu.dataset.level));
      });
    });

    this.$submenus.forEach(submenu => {
      submenu.addEventListener('mouseleave', () => {
        this.hideSubmenu();
      });
    });

    window.addEventListener('scroll-blocker-enable', (event) => {
      if (document.body.classList.contains('rtl')) {
        this.$frame.style.right = event.detail.scrollBarWidth + 'px';
      }
    });
  }

  hideSubmenu(level = null) {
    if (level !== null) {
      this.submenuVisibleLevel -= 1;
    } else {
      this.submenuVisibleLevel = -1;
    }
  }

  updateSections() {
    super.updateSections();
    this.updateItems();
    this.updateSubmenus();
  }

  updateItems() {
    this.$items.forEach(item => {
      const alias = item.dataset.alias;
      const isSelected = (
        this.activeAliases.includes(alias) &&
        this.activeAliases.indexOf(alias) <= this.submenuVisibleLevel
      )

      item.classList.toggle(`${Menu.MENU_ITEM_CLASS}--selected`, isSelected);
    });
  }

  updateSubmenus() {
    this.$submenus.forEach((submenu) => {
      const level = submenu.dataset.level;

      submenu.classList.toggle(`${this.$menuClassName}__level--visible`, level <= this.$submenuVisibleLevel);
    });
  }

}

const menuDesktop = new MenuDesktop(document.querySelector('.menu-desktop'));